import { withStyles } from '@material-ui/core/styles';
import Switch from '@material-ui/core/Switch';


const AntSwitch = withStyles((theme) => ({
    root: {
        width: 51,
        height: 26,
        borderRadius: 13,
        padding: 0,
        display: 'flex',
    },
    switchBase: {
        padding: 4,
        color: "#484848",
        '& + $track': {
            backgroundColor: "#e7e7e7",
            
        },
        '&$checked': {
            transform: 'translateX(24px)',
            color: "#35b9b6",
            '& + $track': {
                opacity: 0.3,
                backgroundColor: "rgba(53 ,185 ,182, 0.8)",
                
            },
        },
    },
    thumb: {
        width: 18,
        height: 18,
        boxShadow: 'none',
    },
    track: {
        
        borderRadius: 16 / 2,
        opacity: 1,
        backgroundColor: theme.palette.common.white,
    },
    checked: {},
  }))(Switch);
  

  export default  AntSwitch;